import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  Checkbox,
  InputNumber,
  Space,
  Spin,
  Table,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import {
  extraService,
  materialTypeService,
  packingTypeService,
  stockClassificationService,
  supplierService,
  measurementTypeService,
} from "_services";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";

let lineIndex = 0;

function Add({ history, match }) {
  const [isLoading, setIsLoading] = useState(false);
  const [isRawMaterialLoading, setIsRawMaterialLoading] = useState(false);
  const [packingTypes, setPackingTypes] = useState([]);
  const [stockClasses, setStockClasses] = useState([]);
  const [materialSuppliers, setMaterialSuppliers] = useState([]);
  const [qualityTypes, setQualityTypes] = useState([]);
  const [materialTypes, setMaterialTypes] = useState([]);
  const [rawMaterials, setRawMaterials] = useState([]);
  const [selectedStockClass, setSelectedStockClass] = useState(null);
  const [measurementTypes, setMeasurementTypes] = useState([]);
  const [materialLines, setMaterialLines] = useState([]);
  const [error, setError] = useState(null);
  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    packingTypeService.getSuggestion().then((x) => {
      setPackingTypes(x.content);
    });
    stockClassificationService.getSuggestion().then((x) => {
      setStockClasses(x.content);
    });
    //getMaterialSuppliers();
    getStockQualityTypes();
    measurementTypeService.getSuggestion().then((data) => {
      setMeasurementTypes(data.content);
    });
  }, []);

  /* const getMaterialSuppliers = () => {
    supplierService
      .getSuggestion()
      .then((x) => {
        setMaterialSuppliers(x.content);
      })
      .catch((errorInfo) => {
        message.error(`${errorInfo}`);
      });
  }; */

  const getStockQualityTypes = () => {
    extraService
      .getQualityTypes()
      .then((x) => {
        setQualityTypes(x.content);
      })
      .catch((errorInfo) => {
        message.error(`${errorInfo}`);
      });
  };

  const handleClassificationChange = (classificationId) => {
    const classification = stockClasses.find(
      (sc) => sc.id === classificationId
    );
    setSelectedStockClass(classification);
    if (classification.name === "FINISHED PRODUCT") {
      const rawMaterialClass = stockClasses.find(
        (sc) => sc.name === "RAW MATERIAL"
      );
      setIsRawMaterialLoading(true);
      materialTypeService
        .getSuggestion(`?stockClassId=${rawMaterialClass.id}`)
        .then((x) => {
          setIsRawMaterialLoading(false);
          setRawMaterials(x.content);
        })
        .catch((errorInfo) => {
          setIsRawMaterialLoading(false);
          message.error(`${errorInfo}`);
        });
    } else {
      setRawMaterials([]);
      setMaterialLines([]);
    }
  };

  const handleAddMaterialLine = () => {
    const defaultMeasurementType = measurementTypes.find(
      (item) => item.name === "KG"
    );

    const newLine =
      defaultMeasurementType === null
        ? {}
        : {
            measurementType: defaultMeasurementType.id,
          };
    newLine.key = lineIndex;
    const lines = [...materialLines, newLine];
    setMaterialLines(lines);
    lineIndex += 1;
  };

  const handleRemoveMaterialLine = (line) => {
    const lines = [...materialLines];
    if (lines.includes(line)) {
      lines.splice(lines.indexOf(line), 1);
      setMaterialLines(lines);
    }
  };

  const handleSaveMaterialLine = (e, key) => {
    e.persist();
    const target = getRowBykey(key) || {};
    if (
      !target.materialType ||
      !target.quantityPerUnit ||
      !target.conversionRatio ||
      !target.wastagePercentage ||
      !target.measurementType
    ) {
      message.error("Please complete the raw material line details.");
      e.target.focus();
      return;
    }
    handleAddMaterialLine();
  };

  const getRowBykey = (key, newData) => {
    return (materialLines || newData).filter((item) => item.key === key)[0];
  };

  const handleFieldChange = (value, fieldName, key) => {
    const lines = [...materialLines];
    const newMaterialLines = lines.map((line) => {
      const newLine = Object.assign({}, line);
      if (newLine.key === key) {
        if (fieldName === "materialType") {
          newLine[fieldName] = rawMaterials.find((item) => item.id === value);
          return newLine;
        } else {
          newLine[fieldName] = value;
          return newLine;
        }
      }
      return newLine;
    });
    //console.log("Lines: ", groupByLines);
    setMaterialLines(newMaterialLines);
  };

  const getLineColumns = () => {
    let columns = [];
    columns.push({
      title: "Material Type",
      dataIndex: "materialType",
      key: "materialType",
      width: "30%",
      render: (text, record) => {
        return (
          <Form.Item
            name={`materialType[${record.key}]`}
            key={record.key}
            style={{ marginBottom: "0" }}
            rules={[{ required: true, message: "Required." }]}
            initialValue={text}
            hasFeedback
          >
            <Select
              placeholder="Please select"
              allowClear
              showSearch
              optionFilterProp="children"
              onChange={(e) => handleFieldChange(e, "materialType", record.key)}
            >
              {rawMaterials.length > 0 &&
                rawMaterials.map((t) => (
                  <Option value={t.id} key={t.id}>
                    {t.code} ({t.name})
                  </Option>
                ))}
            </Select>
          </Form.Item>
        );
      },
    });
    columns.push({
      title: "Quantity Per Unit",
      key: "quantityPerUnit",
      align: "right",
      render: (text, record) => {
        return (
          <Form.Item
            name={`quantityPerUnit[${record.key}]`}
            key={record.key}
            style={{ marginBottom: "0" }}
            rules={[{ required: true, message: "Required." }]}
            hasFeedback
          >
            <InputNumber
              placeholder="Quantity Per Unit"
              min={record._id ? record.quantityPerUnit : 0}
              onChange={(e) =>
                handleFieldChange(e, "quantityPerUnit", record.key)
              }
            />
          </Form.Item>
        );
      },
    });
    columns.push({
      title: "Conversion Ratio",
      key: "conversionRatio",
      align: "right",
      render: (text, record) => {
        return (
          <Form.Item
            name={`conversionRatio[${record.key}]`}
            key={record.key}
            style={{ marginBottom: "0" }}
            rules={[{ required: true, message: "Required." }]}
            hasFeedback
          >
            <InputNumber
              placeholder="Conversion Ratio"
              min={record._id ? record.conversionRatio : 0}
              onChange={(e) =>
                handleFieldChange(e, "conversionRatio", record.key)
              }
            />
          </Form.Item>
        );
      },
    });
    columns.push({
      title: "Wastage Percentage",
      key: "wastagePercentage",
      align: "right",
      render: (text, record) => {
        return (
          <Form.Item
            name={`wastagePercentage[${record.key}]`}
            key={record.key}
            style={{ marginBottom: "0" }}
            rules={[{ required: true, message: "Required." }]}
            hasFeedback
          >
            <InputNumber
              placeholder="Wastage Percentage"
              min={record._id ? record.quantity : 0}
              onChange={(e) =>
                handleFieldChange(e, "wastagePercentage", record.key)
              }
            />
          </Form.Item>
        );
      },
    });
    columns.push({
      title: "UOM",
      dataIndex: "measurementType",
      key: "measurementType",
      render: (text, record) => {
        return (
          <Form.Item
            name={`measurementType[${record.key}]`}
            key={record.key}
            style={{ marginBottom: "0" }}
            rules={[{ required: true, message: "Required." }]}
            initialValue={text}
            hasFeedback
          >
            <Select
              placeholder="Please select"
              allowClear
              showSearch
              optionFilterProp="children"
              onChange={(e) =>
                handleFieldChange(e, "measurementType", record.key)
              }
            >
              {measurementTypes.length > 0 &&
                measurementTypes.map((t) => (
                  <Option value={t.id} key={t.id}>
                    {t.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        );
      },
    });
    columns.push({
      title: "",
      key: "operation",
      render: (text, record) => (
        <Space size="small">
          <Button
            type="primary"
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveMaterialLine(record);
            }}
            icon={<CloseOutlined />}
            style={{ marginLeft: 5 }}
          ></Button>
          <Button
            type="primary"
            onClick={(e) => {
              e.preventDefault();
              handleSaveMaterialLine(e, record.key);
            }}
            style={{ padding: 5, fontSize: 12 }}
          >
            +More
          </Button>
        </Space>
      ),
    });

    return columns;
  };

  const validateMaterialLines = (lines) => {
    let validLines = false;
    if (lines && lines.length > 0) {
      lines.forEach((line) => {
        if (
          line.materialType &&
          line.quantityPerUnit &&
          line.conversionRatio &&
          line.wastagePercentage &&
          line.measurementType
        ) {
          validLines = true;
        }
      });
    }
    return validLines;
  };

  const handleFormSumbit = () => {
    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);

        if (
          selectedStockClass &&
          selectedStockClass.name === "FINISHED PRODUCT"
        ) {
          let rawMaterialLines = [];
          materialLines.forEach((line) => {
            let rawMaterialLine = {};
            rawMaterialLine.materialType = { id: line.materialType.id };
            rawMaterialLine.quantityPerUnit = line.quantityPerUnit;
            rawMaterialLine.conversionRatio = line.conversionRatio;
            rawMaterialLine.wastagePercentage = line.wastagePercentage;
            rawMaterialLine.uom = { id: line.measurementType };

            rawMaterialLines.push(rawMaterialLine);
          });
          values.materials = rawMaterialLines;
        }

        materialTypeService
          .create(values)
          .then(() => {
            setIsLoading(false);
            history.push(".");
          })
          .catch((error) => {
            setIsLoading(false);
            setError(error);
            //message.error(`${error}`);
          });
      })
      .catch((errorInfo) => {});
  };

  const onCancel = () => {
    history.push(".");
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/material-types">Material Type Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/material-types/add">New Material Type</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={[
          <Button
            key="1"
            htmlType="submit"
            loading={isLoading}
            onClick={handleFormSumbit}
          >
            Save
          </Button>,
          <Button key="2" htmlType="button" onClick={onCancel}>
            Cancel
          </Button>,
        ]}
      >
        <Page inner error={error}>
          <Spin tip="Loading..." spinning={isRawMaterialLoading}>
            <Form
              form={form}
              name="form-create"
              layout="vertical"
              requiredMark={false}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name="code"
                    label="HS Code"
                    rules={[{ required: true, message: "HS Code is required" }]}
                  >
                    <Input placeholder="HS Code" allowClear />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="secondaryCode"
                    label="Customer Code"
                    rules={[
                      { required: true, message: "Customer Code is required" },
                    ]}
                  >
                    <Input placeholder="Customer Code" allowClear />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name={["stockClass", "id"]}
                    label="Stock Classification"
                    rules={[
                      {
                        required: true,
                        message: "Stock classification is required",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Please select"
                      allowClear
                      onChange={handleClassificationChange}
                    >
                      {stockClasses.map((t) => (
                        <Option value={t.id} key={t.id}>
                          {t.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  {/* <Form.Item
                    name={["supplier", "id"]}
                    label="Material Supplier"
                    rules={[
                      {
                        required: true,
                        message: "Material Supplier is required",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      allowClear
                      showArrow={false}
                      optionFilterProp="children"
                      placeholder="Material Supplier"
                    >
                      {materialSuppliers.map((t) => (
                        <Select.Option value={t.id} key={t.id}>
                          {t.name} ({t.code})
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item> */}
                </Col>
                <Col span={6}></Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name="name"
                    label="Name"
                    rules={[{ required: true, message: "Name is required" }]}
                  >
                    <Input placeholder="Name" allowClear />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name={["packingType", "id"]}
                    label="Packing Type"
                    rules={[
                      { required: true, message: "Packing Type is required" },
                    ]}
                  >
                    <Select placeholder="Please select" allowClear>
                      {packingTypes.map((t) => (
                        <Option value={t.id} key={t.id}>
                          {t.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                {/* <Col span={6}>
                <Form.Item name={["qualityType", "id"]} label="Quality Type" rules={[
                  {
                    required: true,
                    message: "Quality Type is required",
                  },
                ]}>
                  <Select
                    showSearch
                    allowClear
                    showArrow={false}
                    optionFilterProp="children"
                    placeholder="Quality Type"
                  >
                    {qualityTypes.map((t) => (
                      <Select.Option value={t.id} key={t.id}>
                        {t.name} ({t.code})
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col> */}
                <Col span={6}></Col>
              </Row>

              {materialLines.length > 0 && (
                <Table
                  bordered
                  pagination={false}
                  columns={getLineColumns()}
                  dataSource={materialLines}
                  size="small"
                />
              )}
              {selectedStockClass &&
                selectedStockClass.name === "FINISHED PRODUCT" &&
                materialLines.length === 0 && (
                  <Button
                    style={{
                      width: "100%",
                      marginTop: 16,
                      marginBottom: 8,
                      color: "white",
                      backgroundColor: "#13c2c2",
                    }}
                    type="dashed"
                    onClick={handleAddMaterialLine}
                    icon={<PlusOutlined />}
                  >
                    Add Material
                  </Button>
                )}
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Add;
